
export default function ProductPortfolio() {
  const products = [
    {
      icon: 'ri-map-2-line',
      title: 'Tour Truyền Thống Chất Lượng Cao',
      description: 'Chuẩn hóa chất lượng dịch vụ, tập trung vào quyền lợi khách hàng & đại lý. Sản phẩm chủ lực dễ bán nhất.',
      image: 'https://public.readdy.ai/ai/img_res/8b79605ca84591d22e4445c42e75d262.jpg',
      highlight: 'Sản phẩm chủ lực'
    },
    {
      icon: 'ri-landscape-line',
      title: 'Truyền Thống + Di Sản Thiên Nhiên',
      description: 'Bryce Canyon, Antelope Canyon, Horseshoe Bend, Route 66, Valley of Fire. Tạo sự khác biệt mạnh trên thị trường.',
      image: 'https://readdy.ai/api/search-image?query=breathtaking%20view%20of%20Antelope%20Canyon%20with%20stunning%20light%20beams%2C%20vibrant%20orange%20and%20red%20rock%20formations%2C%20natural%20wonder%2C%20professional%20landscape%20photography%2C%20dramatic%20lighting%2C%20simple%20natural%20background&width=600&height=400&seq=product-002&orientation=landscape',
      highlight: 'Khác biệt mạnh'
    },
    {
      icon: 'ri-plane-line',
      title: 'Free & Easy – Bắt Đầu Tại Mỹ',
      description: 'Dành cho khách thăm thân, khởi hành từ Los Angeles / San Francisco / New York. Giá cạnh tranh cực mạnh.',
      image: 'https://readdy.ai/api/search-image?query=young%20couple%20travelers%20with%20backpacks%20exploring%20San%20Francisco%20Golden%20Gate%20Bridge%2C%20casual%20travel%20style%2C%20freedom%20and%20adventure%20theme%2C%20bright%20sunny%20day%2C%20professional%20travel%20photography%2C%20simple%20clean%20background&width=600&height=400&seq=product-003&orientation=landscape',
      highlight: 'Giá cạnh tranh'
    },
    {
      icon: 'ri-roadster-line',
      title: 'Phượt Mỹ – Caravan – RV – Roadtrip',
      description: 'USP sản phẩm độc quyền, hấp dẫn với khách trẻ và khách yêu trải nghiệm. Mảng sẽ bùng nổ từ 2026–2027.',
      image: 'https://readdy.ai/api/search-image?query=modern%20RV%20camper%20van%20driving%20on%20scenic%20American%20highway%20Route%2066%20with%20desert%20landscape%2C%20adventure%20travel%20concept%2C%20sunset%20golden%20hour%2C%20professional%20photography%2C%20inspiring%20atmosphere%2C%20simple%20natural%20background&width=600&height=400&seq=product-004&orientation=landscape',
      highlight: 'Độc quyền - Bùng nổ 2026'
    },
    {
      icon: 'ri-train-line',
      title: 'Tour Kết Hợp Đường Bộ & Đường Sắt',
      description: 'Tuyến mới – thị trường cực ít đơn vị khai thác. Mức nhận dạng cao – dễ viral.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20scenic%20train%20traveling%20through%20beautiful%20American%20Rocky%20Mountains%20landscape%2C%20panoramic%20windows%2C%20premium%20travel%20experience%2C%20professional%20photography%2C%20majestic%20mountain%20views%2C%20simple%20natural%20background&width=600&height=400&seq=product-005&orientation=landscape',
      highlight: 'Dễ viral'
    },
    {
      icon: 'ri-building-line',
      title: 'Tour Hội Chợ – B2B – MICE',
      description: 'Tập trung doanh nghiệp, kết nối thương mại. Là sản phẩm đột phá thị trường Việt – Mỹ.',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20conference%20and%20trade%20show%20in%20modern%20American%20convention%20center%2C%20business%20people%20networking%2C%20corporate%20event%2C%20bright%20professional%20lighting%2C%20clean%20modern%20background&width=600&height=400&seq=product-006&orientation=landscape',
      highlight: 'Đột phá thị trường'
    },
    {
      icon: 'ri-car-line',
      title: 'Phân Phối Land Tour & Vận Tải',
      description: 'Xe 12/15/25/50 chỗ, tài xế người Việt. Đón tiễn sân bay / dịch vụ đoàn công tác.',
      image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20tour%20bus%20and%20professional%20Vietnamese%20driver%20in%20uniform%20at%20American%20airport%2C%20premium%20transportation%20service%2C%20clean%20professional%20style%2C%20bright%20daylight%2C%20simple%20clean%20background&width=600&height=400&seq=product-007&orientation=landscape',
      highlight: 'Dịch vụ toàn diện'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Du Học – BĐS – Định Cư',
      description: 'Sản phẩm mở rộng cho đại lý có hệ sinh thái khách. Thêm nguồn thu cao, ổn định.',
      image: 'https://readdy.ai/api/search-image?query=happy%20international%20students%20at%20prestigious%20American%20university%20campus%20with%20iconic%20buildings%2C%20graduation%20caps%2C%20success%20and%20achievement%20theme%2C%20bright%20sunny%20day%2C%20professional%20photography%2C%20simple%20clean%20background&width=600&height=400&seq=product-008&orientation=landscape',
      highlight: 'Nguồn thu ổn định'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
            Bộ Sản Phẩm Độc Quyền & Chiến Lược
          </h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-400 mx-auto mb-6 sm:mb-8"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto px-4">
            8 nhóm sản phẩm đa dạng, từ truyền thống đến độc quyền, đáp ứng mọi phân khúc khách hàng
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mb-10 sm:mb-12">
          {products.map((product, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                <img 
                  src={product.image}
                  alt={product.title}
                  title={product.title}
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-blue-600 text-white px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg">
                  {product.highlight}
                </div>
              </div>
              
              <div className="p-5 sm:p-6">
                <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                    <i className={`${product.icon} text-blue-600 text-xl sm:text-2xl`}></i>
                  </div>
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 leading-tight">{product.title}</h3>
                </div>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{product.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center px-4">
          <a 
            href="#benefits"
            className="inline-block w-full sm:w-auto px-6 sm:px-8 md:px-10 py-4 sm:py-5 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm sm:text-base md:text-lg font-bold rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Nhận Bộ Sản Phẩm Bán Sẵn + Saleskit
          </a>
        </div>
      </div>
    </section>
  );
}